export class Article {
  lemma = new Lemma();
  explanations = new Explanations();
  examples: Example[] = [];
}

export class DanishLemma {
  word = "";
  alternative = "";
  preposition = "";

  conjugations: string[][] = [];

  wordclass = new WordClass();
}

export enum ArabicConjugationType {
  Definit,
  Femininum,
  Imperfektum,
  Pluralis
}

export class ArabicConjugation {
  private static readonly TYPE_MAP = {
    [ArabicConjugationType.Definit]: { text: "Definit", abbreviation: "def" },
    [ArabicConjugationType.Femininum]: { text: "Femininum", abbreviation: "fem" },
    [ArabicConjugationType.Imperfektum]: { text: "Imperfektum", abbreviation: "imp" },
    [ArabicConjugationType.Pluralis]: { text: "Pluralis", abbreviation: "pl" }
  };

  constructor(
    public text: string,
    public type: ArabicConjugationType
  ) {}

  getType(): string {
    return ArabicConjugation.TYPE_MAP[this.type].text;
  }

  getAbbreviatedType(): string {
    return ArabicConjugation.TYPE_MAP[this.type].abbreviation;
  }
}

export class ArabicLemma {
  word = "";
  pronunciation = "";
  preposition = "";

  root = "";
  form = "";

  conjugations: ArabicConjugation[] = [];

  wordclass = new WordClass();
}

export class Explanation {
  prefix?: string;
  text = "";
}

class Lemma {
  danish = new DanishLemma();
  arabic = new ArabicLemma();
}

class WordClass {
  short = "";
  latin = "";
  danish = "";
}

class Explanations {
  danish: Explanation[] = [];
  arabic: Explanation[] = [];

  addDanish(text: string, prefix?: string): void {
    if (!text) {
      return;
    }

    this.danish.push({ text, prefix });
  }

  addArabic(text: string, prefix?: string): void {
    if (!text) {
      return;
    }

    this.arabic.push({ text, prefix });
  }

  hasAny(): boolean {
    return this.hasDanish() || this.hasArabic();
  }

  hasDanish(): boolean {
    return this.danish.length > 0;
  }

  hasArabic(): boolean {
    return this.arabic.length > 0;
  }
}

interface Example {
  danish: string;
  arabic: string;
}
